// 1:1 wrapper around apiv2 `clinical_view.getdashboard` (ACL_Session, POST).
// Session-authed like the patient companion's get_patient_home — so it goes
// straight to apiv2 via ws() (NOT WF50, which signs with the RSA key and holds
// no session). Params must already be apiv2-shaped (clinical_role, clinical_search,
// is_list filters as CSV). Throws (WsError) on a non-OK status — see services convention.

import { ws } from '@/lib/wiservice';
import type { DashboardEnvelope } from '@/logic/dashboard';

export interface ClinicalViewDashboardBody {
  data?: DashboardEnvelope['data'];
  meta?: { total_count?: number; offset?: number; limit?: number; include?: unknown };
}

export async function getDashboard(params: Record<string, unknown>): Promise<ClinicalViewDashboardBody> {
  const res = await ws<ClinicalViewDashboardBody>('clinical_view', 'getdashboard', params);
  return res.body;
}
